export default __webpack_public_path__ + "static/media/alphabet-yellow-l.c5990842.png";